module.exports = __webpack_public_path__ + "img/selected-car.dd00b7c0.png";